import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { DepositService } from '../../../../service/deposit.service';
import { DepositRedirectService } from '../../../../service/depositRedirect.service';
import { ResizeService } from '../../../../service/resize.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-redirect-message',
    templateUrl: 'redirect-message.component.html',
    imports: [MessageComponent, TranslateModule],
})
export class RedirectMessageComponent {
    depositRedirectService = inject(DepositRedirectService);
    private depositService = inject(DepositService);
    private resizeService = inject(ResizeService);

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor() {
        this.resizeService.resizeCashier();
    }

    redirectToThirdParty() {
        this.depositRedirectService.redirectToThirdParty(this.depositService.handleResponse);
        this.resizeService.resizeCashier();
    }
}
